import React, { useEffect } from "react";
import moment from "moment";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { Card, Col, Container, Row, Spinner } from "reactstrap";
import { verifyTalkingBadge } from "store/actions/VerifyBadgesAction";
import ReuseableTable from "components/Tables/ReuseableTable";
const VerifyTalkingBadges = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [dataLoader, setDataLoader] = useState(true);
  useEffect(() => {
    dispatch(
      verifyTalkingBadge(id, () => {
        setDataLoader(false);
      })
    );
  }, []);
  const { talkingBadges } = useSelector((state) => state.verifyBadges);
  const TABLE_DATA = {
    columns: [
      "Fan Name",
      "Fan Email",
      "Athlete Name",
      "Athlete Email",
      "Purchase Amount",
      "Purchase Date",
    ],
    keyMap: {
      "Fan Name": "fanName",
      "Fan Email": "fanEmail",
      "Athlete Name": "athleteFirstName",
      "Athlete Email": "athleteEmail",
      "Purchase Amount": "dataAmount",
      "Purchase Date": "dataCreatedAtSeconds",
    },
    data: {
      fanName: talkingBadges.fan.name,
      fanEmail: talkingBadges.fan.email,
      athleteFirstName:
        talkingBadges.athlete.first_name +
        " " +
        talkingBadges.athlete.last_name,
      athleteEmail: talkingBadges.athlete.email,
      dataAmount: talkingBadges.data.amount,
      dataCreatedAtSeconds: moment
        .unix(talkingBadges.data.createdAt.seconds)
        .format("D MMM YYYY"),
    },
  };
  return (
    <Container className="pt-4">
      <Row className="mt-4">
        <Col md="12">
          <Card className="p-4">
            <h1 className="text-center">This badge details </h1>
            {dataLoader ? (
              <div className="text-center">
                <Spinner color="primary" />
              </div>
            ) : Object.keys(talkingBadges).length === 0 ? (
              <p>This Badge not found</p>
            ) : (
              <>
                <ReuseableTable {...TABLE_DATA} />
              </>
            )}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default VerifyTalkingBadges;
